import clsx from "clsx";
import React from "react";
import styles from "./styles.module.scss";
import { cva, type VariantProps } from "class-variance-authority";

// eslint-disable-next-line react-refresh/only-export-components
export const buttonVariants = cva(styles._onetouchai_button, {
  variants: {
    variant: {
      primary: styles._onetouchai_primary,
      outline: styles._onetouchai_outline,
    },
    size: {
      sm: styles._onetouchai_small,
      md: styles._onetouchai_medium,
    },
  },
  defaultVariants: {
    variant: "primary",
    size: "md",
  },
});

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, ...props }, ref) => {
    return (
      <button
        className={clsx(buttonVariants({ variant, size }), className)}
        ref={ref}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";

export default Button;
